import { Link } from "gatsby";
import * as React from "react";
import { PropsWithChildren } from "react";

import { StateForm } from "../Forms/useForm";
import { useModal } from "../Modals/useModal";
import { withModal } from "../Modals/withModal";
import ContactForm from "../Organisms/ContactForm/ContactForm";

enum TypeCTA {
  link = "link",
  href = "href",
  button = "button",
  span = "span",
}

type PropsButton = PropsWithChildren<{
  as?: TypeCTA;
  fromRender?: string;
  arial?: string;
  type?: "button" | "submit" | "reset";
  state?: StateForm;
  disabled?: boolean;
  handleClick?: () => void;
  actionLink?: string | "modal" | undefined | null;
}>;

const Button: React.FC<PropsButton> = (props: PropsButton) => {
  if (!props.children) return null;

  const type = props.type ? props.type : "button";

  const disabled = props.disabled ? props.disabled : false;

  const className = `m-button m-button--red
    ${props.state === StateForm.SUCCESS ? "m-button--success" : ""}
    ${props.state === StateForm.SUBMITTING ? "m-button--submitting" : ""}
    ${props.state === StateForm.FAIL ? "m-button--fail" : ""}
  `;

  if (props.handleClick) {
    return (
      <button
        type={type}
        aria-label={props.arial}
        disabled={disabled}
        className={className}
        onClick={props.handleClick}
      >
        {props.children}
      </button>
    );
  }

  if (props.actionLink && props.actionLink !== "modal") {
    return (
      <Link
        aria-label={props.arial}
        title={props.arial}
        to={props.actionLink}
        className={className}
      >
        {props.children}
      </Link>
    );
  }

  const [has_modal, toggleModal] = useModal();
  const InfoFormUseWithModal = withModal(
    ContactForm,
    { place: props.fromRender },
    {
      has_modal,
      toggleModal,
    },
  );
  return (
    <>
      <InfoFormUseWithModal />
      <button
        aria-label={props.arial}
        type={type}
        disabled={disabled}
        // className={className}
        className={`m-navbar__button
            m-button m-button--red`}
        onClick={toggleModal}
      >
        <span> {props.children} </span>
      </button>
    </>
  );
};

export default Button;
